class PageType {
    static PAGE = 0;
    static DIALOG = 1;
    static DRAWER = 2;
}

export default PageType;